import { Typography, Stack, Link } from '@mui/material';
import { CustomButton, Loader, ResponsiveBreak } from 'src/components';

interface IProps {
  testLink: string | null;
}

export const BackToTest = ({ testLink }: IProps): JSX.Element => {
  return (
    <>
      <Typography
        variant="h2"
        sx={(theme) => ({
          fontSize: '2rem',
          [theme.breakpoints.down('sm')]: {
            fontSize: '1.25rem',
            maxWidth: '70%',
          },
          [theme.breakpoints.down('xl')]: {
            fontSize: '1.5rem',
          },
        })}
      >
        First step is done, <ResponsiveBreak breakpoint="md" />
        now it’s time to show your skills
      </Typography>
      <Stack spacing={1} direction="column" mt={4}>
        <Typography
          variant="body1"
          mb={1}
          data-testid="tt-pending-result-subtext"
          sx={(theme) => ({
            [theme.breakpoints.up('lg')]: {
              whiteSpace: 'nowrap',
            },
          })}
        >
          Please finish your{' '}
          <Link role="link" href={testLink ?? '#'}>
            coding test on HackerRank
          </Link>{' '}
          and wait for results.
        </Typography>
        <Loader position="auto" />
        <Typography component={'span'} variant="body1" mt={4}>
          <CustomButton
            color="primary"
            label="Back to the test"
            testid="back-to-test-button"
            onClick={() => {
              window.location.replace(testLink || '#');
            }}
            maxWidth="16rem"
            fullWidth
          />
        </Typography>
      </Stack>
    </>
  );
};
